export const comparisonTable = [
  { feature: 'Pricing Transparency', itaobuy: '★★★★★', agents: '★★☆☆☆', direct: '★★★☆☆' },
  { feature: 'Ease of Ordering', itaobuy: '★★★★★', agents: '★★★☆☆', direct: '★☆☆☆☆' },
  { feature: 'Buyer Protection', itaobuy: '★★★★☆', agents: '★★★☆☆', direct: '★★☆☆☆' },
  { feature: 'Order Tracking', itaobuy: '★★★★★', agents: '★★★☆☆', direct: '★★☆☆☆' },
  { feature: 'Bulk Order Support', itaobuy: '★★★★★', agents: '★★★☆☆', direct: '★☆☆☆☆' },
  { feature: 'Shipping Speed', itaobuy: '★★★★☆', agents: '★★★☆☆', direct: '★★★☆☆' },
];

export const safetyTable = [
  { risk: 'Fake Seller Listings', cause: 'Unverified product links', solution: 'Spreadsheet link verification system' },
  { risk: 'Wrong Items Received', cause: 'Order miscommunication', solution: 'Structured data input eliminates ambiguity' },
  { risk: 'Shipping Delays', cause: 'Complex logistics chains', solution: 'Real-time tracking via spreadsheet system' },
  { risk: 'Hidden Agent Fees', cause: 'Opaque pricing from middlemen', solution: 'Transparent line-item pricing in every order' },
];

export const trustBadges = [
  { icon: 'ri-shield-check-line', label: 'Verified System' },
  { icon: 'ri-eye-line', label: 'Full Transparency' },
  { icon: 'ri-flashlight-line', label: 'Fast Processing' },
  { icon: 'ri-money-dollar-circle-line', label: 'Lower Total Cost' },
];

export const whyReasons = [
  { icon: 'ri-close-circle-line', title: 'No Hidden Agent Markups', desc: 'Traditional agents layer unpredictable fees onto every purchase. The itaobuyspreadsheet system shows you exactly what you pay, line by line, so nothing is ever hidden.' },
  { icon: 'ri-file-list-3-line', title: 'Centralized Product Tracking', desc: 'Manage dozens or hundreds of items in one structured view. Every product, variant, and status update lives in your itaobuyspreadsheet — no more scattered chat logs.' },
  { icon: 'ri-stack-line', title: 'Built for Bulk Ordering', desc: 'Whether you are buying 5 items or 500, the itaobuyspreadsheet method scales effortlessly. Batch submissions, consolidated shipping, and organized workflows save hours.' },
  { icon: 'ri-settings-3-line', title: 'Full Control Over Purchases', desc: 'Unlike agents who make decisions on your behalf, the itaobuyspreadsheet approach puts you in the driver\'s seat. You choose, you verify, you approve — every step of the way.' },
  { icon: 'ri-global-line', title: 'Optimized for International Buyers', desc: 'Designed specifically for shoppers outside China, with English interfaces, international shipping integration, and currency clarity built into the spreadsheet workflow.' },
];

export const articleCards = [
  {
    title: 'What Is ItaobuySpreadsheet?',
    slug: '/what-is-itaobuyspreadsheet',
    desc: 'A complete introduction to the spreadsheet-based China shopping method that is changing how international buyers source products.',
    color: 'bg-accent-100',
    imgSeq: 'article-what-is-v2',
  },
  {
    title: 'How to Use ItaobuySpreadsheet',
    slug: '/how-to-use-itaobuyspreadsheet',
    desc: 'Step-by-step walkthrough from finding products to submitting your first spreadsheet order — designed for absolute beginners.',
    color: 'bg-secondary-100',
    imgSeq: 'article-how-to-v2',
  },
  {
    title: 'ItaobuySpreadsheet vs Agents',
    slug: '/itaobuyspreadsheet-vs-agents',
    desc: 'Head-to-head comparison of pricing, speed, accuracy, and buyer protection between spreadsheet ordering and traditional shopping agents.',
    color: 'bg-primary-100',
    imgSeq: 'article-vs-v2',
  },
  {
    title: 'Safety & Buyer Protection Guide',
    slug: '/itaobuyspreadsheet-safety-guide',
    desc: 'An honest, detailed look at how the spreadsheet system prevents fraud, reduces errors, and protects your purchases.',
    color: 'bg-accent-100',
    imgSeq: 'article-safety-v2',
  },
  {
    title: 'Complete Pricing Breakdown',
    slug: '/itaobuyspreadsheet-pricing-guide',
    desc: 'Transparent cost analysis — product prices, domestic shipping, international freight, and platform fees explained with real examples.',
    color: 'bg-secondary-100',
    imgSeq: 'article-pricing-v2',
  },
  {
    title: 'Beginner\'s First Order Guide',
    slug: '/itaobuyspreadsheet-for-beginners',
    desc: 'Never ordered from China before? This friendly guide walks you through your first successful spreadsheet order step by step.',
    color: 'bg-primary-100',
    imgSeq: 'article-beginner-v2',
  },
  {
    title: 'Expert Tips & Power Strategies',
    slug: '/china-shopping-spreadsheet-tips',
    desc: 'Advanced techniques from experienced users — batch sourcing, seasonal timing, negotiation through notes, and optimization tricks.',
    color: 'bg-accent-100',
    imgSeq: 'article-tips-v2',
  },
  {
    title: 'Bulk Orders & Scaling Guide',
    slug: '/itaobuyspreadsheet-bulk-orders',
    desc: 'How small businesses source hundreds of items efficiently through the spreadsheet system with inventory planning and logistics.',
    color: 'bg-secondary-100',
    imgSeq: 'article-bulk-v2',
  },
  {
    title: 'International Shipping Guide',
    slug: '/itaobuyspreadsheet-shipping-guide',
    desc: 'Everything about shipping — courier options, customs duties, consolidation strategies, and delivery time estimates by region.',
    color: 'bg-primary-100',
    imgSeq: 'article-shipping-v2',
  },
  {
    title: 'Frequently Asked Questions',
    slug: '/itaobuyspreadsheet-faq',
    desc: 'The most comprehensive FAQ resource with honest answers about ordering, returns, payments, and troubleshooting from real users.',
    color: 'bg-accent-100',
    imgSeq: 'article-faq-v2',
  },
];